import { Controller } from '@hotwired/stimulus';
import { WebViewEvent, checkIfIosWebView } from '@infakt/webview-toolkit';

const APP_STORE_URL = 'https://itunes.apple.com/pl/app/infakt-fakturowanie-i-ksiegowosc/id875266244?mt=8';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=pl.infakt.infakt&hl=pl';

export default class extends Controller {
  #isSubmittingWaitlist = false;
  #isRemovingFromWaitlist = false;
  #isPreparing = false;

  static values = {
    successUrl: String,
  };

  goToStore() {
    new WebViewEvent({
      event: 'OpenBrowser',
      params: {
        url: checkIfIosWebView() ? APP_STORE_URL : GOOGLE_PLAY_URL,
      },
    }).dispatch();
  }

  showMissingCompanyDataMessage() {
    notyf.open({
      type: 'error',
      message: 'Uzupełnij najpierw dane Twojej firmy, aby otworzyć konto firmowe',
    });
  }

  async sendOnboardingWebviewEvent(event) {
    if (this.#isPreparing) return;
    this.#isPreparing = true;
    const button = event?.currentTarget;
    if (button) button.disabled = true;

    try {
      const redirectUrl = await this.#prepareAmlCompany();

      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }

      new WebViewEvent({
        event: 'InitSetupMobile',
        params: {},
      }).dispatch();
    } finally {
      this.#isPreparing = false;
      if (button) button.disabled = false;
    }
  }

  async addToWaitlist(event) {
    if (this.#isSubmittingWaitlist) return;
    this.#isSubmittingWaitlist = true;
    const button = event?.currentTarget;
    button.disabled = true;

    try {
      const response = await fetch('/api/infakt_app/banking_onboarding/waitlist', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.#csrfToken,
        },
      });

      if (response.ok) {
        window.location.href = this.successUrlValue;
        return;
      }

      notyf.open({
        type: 'error',
        message: 'Nie udało się zapisać zgłoszenia. Spróbuj ponownie.',
      });
    } catch (error) {
      console.error(error);
    } finally {
      this.#isSubmittingWaitlist = false;
      button.disabled = false;
    }
  }

  async removeFromWaitlist(event) {
    if (this.#isRemovingFromWaitlist) return;
    this.#isRemovingFromWaitlist = true;
    const button = event?.currentTarget;
    button.disabled = true;

    try {
      const response = await fetch('/api/infakt_app/banking_onboarding/waitlist', {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.#csrfToken,
        },
      });

      if (response.ok) {
        window.location.href = window.location.pathname;
        return;
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.#isRemovingFromWaitlist = false;
      button.disabled = false;
    }
  }

  get #csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }

  async #prepareAmlCompany() {
    try {
      const response = await fetch('/api/infakt_app/banking_onboarding/prepare', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.#csrfToken,
        },
      });

      if (response.ok) return null;

      const body = await response.json().catch(() => ({}));

      return body.redirect_url ?? null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
